import { atom } from "jotai";

/**
 * Narrow escape hatch: allow a one-time save even in view-only mode.
 * Intended for the embed one-shot autolayout flow triggered by `?autolayout=1`, where we need
 * to persist node positions after layout.
 */
export const allowPersistenceInViewOnlyModeAtom = atom<boolean>(false);

allowPersistenceInViewOnlyModeAtom.debugLabel =
  "allowPersistenceInViewOnlyModeAtom";
